import { JSX } from 'react';
import { C07PromoCTAProps } from './C07PromoCTA.types';
import { PromoCallout } from '@ahc-digital/component-library';
import { GetPromoCalloutModel } from './C07PromoCTA.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C07PromoCTAProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <PromoCallout
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...GetPromoCalloutModel(props)}
    />
  );
};

export default checkDatasourceForRendering<C07PromoCTAProps>(Default);
